module.exports = __webpack_public_path__ + "static/img/y_znzz21.331953d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_znzz21.png
// module id = Hx3g
// module chunks = 73